import React, {CSSProperties} from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {createTheme} from "@mui/material";

export const theme = createTheme({
    palette: {
        primary: {
            main: '#556cd6',
        },
        secondary: {
            main: '#dc3545',
        },
    },
    components: {
        MuiAccordion: {
            defaultProps: {
                TransitionProps: {timeout: 50}
            }
        },
        MuiAccordionSummary: {
            defaultProps: {
                style: {backgroundColor: "#f5f5f5"},
                expandIcon: <ExpandMoreIcon/>
            }
        },
        MuiTextField: {
            defaultProps: {
                variant: "standard"
            }
        },
        MuiSelect: {
            defaultProps: {
                variant: "standard"
            }
        }
    }
});

export const creditTableRowStyle: CSSProperties = {
    borderColor: "#8fd19e",
    backgroundColor: "#c3e6cb"
}

export const rowErrorColor = "#f5c6cb";
export const rowWarningColor = "#ffeeba";

export const debitTableRowStyle: CSSProperties = {
    borderColor: "#ed969e",
    backgroundColor: rowErrorColor
}

export const payAttentionTableRowStyle: CSSProperties = {
    borderColor: "#7abaff",
    backgroundColor: "#b8daff"
}

export const inconsistentTableRowStyle: CSSProperties = {
    borderColor: "#ffdf7e",
    backgroundColor: rowWarningColor
}